(() => {
  if (customElements.get('giulia-landing')) return;

  customElements.define(
    'giulia-landing',
    class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();

        const signal = this.abort.signal;

        this.classList.add('is-ready');

        this.querySelectorAll('[data-copy]').forEach((button) => {
          button.hidden = false;
        });

        // 切换商品 Collection
        const select = (key) => {
          this.querySelectorAll('[data-panel]').forEach((panel) => {
            panel.hidden = panel.dataset.panel !== key;
          });

          this.querySelectorAll('[data-tab]').forEach((tab) => {
            const active = tab.dataset.tab === key;

            tab.classList.toggle('is-active', active);

            if (active) {
              tab.setAttribute('aria-current', 'true');
            } else {
              tab.removeAttribute('aria-current');
            }
          });
        };

        select('all');

        this.addEventListener(
          'click',
          async (event) => {
            const tab = event.target.closest('[data-tab]');

            if (tab && this.contains(tab)) {
              event.preventDefault();
              select(tab.dataset.tab);
            }

            // 关闭吸底优惠栏
            const close = event.target.closest('[data-close]');

            if (close) {
              this.querySelector('[data-sticky]').hidden = true;
              this.style.setProperty('--gl-sticky-height', '0px');
            }

            // 复制优惠码
            const copy = event.target.closest('[data-copy]');

            if (copy) {
              const status = this.querySelector('[data-status]');

              try {
                await navigator.clipboard.writeText(copy.dataset.copy);

                status.textContent = this.dataset.copied;

                const original = copy.textContent;

                copy.textContent = this.dataset.copied;
                copy.disabled = true;

                setTimeout(() => {
                  if (copy.isConnected) {
                    copy.textContent = original;
                    copy.disabled = false;
                  }
                }, 1800);
              } catch (_) {
                window.prompt(
                  this.dataset.copyError,
                  copy.dataset.copy
                );
              }
            }
          },
          { signal }
        );

        // 在主题编辑器中选中分类时，显示对应商品
        document.addEventListener(
          'shopify:block:select',
          (event) => {
            if (!this.contains(event.target)) return;

            const tab =
              event.target.closest('[data-tab]') ||
              event.target.querySelector('[data-tab]');

            if (tab) {
              select(tab.dataset.tab);
            }
          },
          { signal }
        );

        // 根据吸底栏实际高度预留空间
        const sticky = this.querySelector('[data-sticky]');

        if (sticky) {
          const resize = () => {
            const height = sticky.hidden
              ? 0
              : sticky.getBoundingClientRect().height;

            this.style.setProperty(
              '--gl-sticky-height',
              `${height}px`
            );
          };

          this.observer = new ResizeObserver(resize);
          this.observer.observe(sticky);

          resize();
        }
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
      }
    }
  );
})();